import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';

import { isNodeEnvironment } from '../../js/utils-fetch-data-json.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';

export async function fetchAllCategories() {
  try {
    if (isNodeEnvironment()) {
      //console.log("🌐 Fetching All products from pre-built data");

      //const data = await myFetchJsonContentFromBuildData("categories.json");

      ////console.log("Filtered Data:", data);

      //if (data && data[appState.SiteLanguageCookie]) {
      //    const products = data[appState.SiteLanguageCookie];
      //    console.log(`✅ Loaded All categories for language '${appState.SiteLanguageCookie}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${appState.SiteLanguageCookie}'`);
      //    return [];
      //}

      return [];
    } else {
      const storageKey = `All_Categories_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);

      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log('✅ Loaded All categories from cache');
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetListOfAllDepartmentsAsync?languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok) throw new Error('Failed to fetch All categories from server');

      const allCategories = await response.json();

      // Save to localStorage
      saveToLocalStorage(storageKey, allCategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log('🌐 Fetched All categories from the server');
      return allCategories;
    }
  } catch (error) {
    console.error('❌ Error fetching home page All categories:', error);
    return [];
  }
}

export async function fetchAllSubcatgoriesInCategory(selectedCategoryID) {
  try {
    if (isNodeEnvironment()) {
      return [];
      console.log('🌐 Fetching All products from pre-built data');
      //const data = await myFetchJsonContentFromBuildData("categories.json");
      ////console.log("Filtered Data:", data);
      //if (data && data[lang]) {
      //    const products = data[lang];
      //    console.log(`✅ Loaded All categories for language '${lang}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${lang}'`);
      //    return [];
      //}
    } else {
      const storageKey = `Subcategories_in_category_${selectedCategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);
      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All Subcategories for ${selectedCategoryID} from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetAllPublishedCategoriesInDepartmentByDepartmentIDAsync?departmentID=${selectedCategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);
      if (!response.ok)
        throw new Error(`Failed to fetch All Subcategories for ${selectedCategoryID} from server`);
      const allSubcategories = await response.json();
      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched All Subcategories for ${selectedCategoryID} from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetching home page All categories:', error);
    return [];
  }
}

export async function fetchAllProductsInSubcatgory(selectedSubcategoryID) {
  try {
    if (isNodeEnvironment()) {
      return [];

      console.log('🌐 Fetching All products from pre-built data');

      //const data = await myFetchJsonContentFromBuildData("categories.json");

      ////console.log("Filtered Data:", data);

      //if (data && data[lang]) {
      //    const products = data[lang];
      //    console.log(`✅ Loaded All categories for language '${lang}' from pre-built data`);
      //    return products;
      //} else {
      //    console.warn(`⚠️ No All categories found for language '${lang}'`);
      //    return [];
      //}
    } else {
      const storageKey = `Products_in_Subcategory_${selectedSubcategoryID}_${appState.SiteLanguageCookie}`;
      const expiryKey = `${storageKey}_expiry`;
      const expiryDuration = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds

      // Check cache first
      const cached = loadFromLocalStorage(storageKey);
      const expiryTime = loadFromLocalStorage(expiryKey);

      if (cached && expiryTime && Date.now() < parseInt(expiryTime)) {
        console.log(`✅ Loaded All Products for Subcategory ${selectedSubcategoryID} from cache`);
        return cached;
      }

      const apiEndPoint = `${APP_CONFIG.API_ENDPOINTS.CatalogAPI}/api/CatalogDataService/GetAllPublishedProductsInCategoryByCategoryIDAsync?categoryID=${selectedSubcategoryID}&languageCode=${appState.SiteLanguageCookie}`;
      const response = await fetch(apiEndPoint);

      if (!response.ok)
        throw new Error(
          `Failed to fetch All Subcategories for ${selectedSubcategoryID} from server`
        );

      const allSubcategories = await response.json();

      // Save to localStorage
      saveToLocalStorage(storageKey, allSubcategories);
      saveToLocalStorage(expiryKey, Date.now() + expiryDuration);
      console.log(`🌐 Fetched All Subcategories for ${selectedSubcategoryID} from the server`);
      return allSubcategories;
    }
  } catch (error) {
    console.error('❌ Error fetching home page All categories:', error);
    return [];
  }
}
